import React, { useState, useEffect } from "react";
import { useRef } from "react";
import {
    motion,
    useMotionValue,
    useTransform,
    useAnimationFrame
} from "framer-motion";
import { wrap } from "@motionone/utils";
import PartnerMarquee from "./Hello";
import PartnerGrid from "./Hellomobile";
import { useIsDesktop } from "./@hooks/useMediaQuery";

interface ParallaxProps {
    children: any;
    baseVelocity: number;
}
function ParallaxText({ children, baseVelocity = 100 }: ParallaxProps) {
    const baseX = useMotionValue(0);
    const x = useTransform(baseX, v => ` ${wrap(-v, 0, v)}px`);
    // const x = useTransform(baseX, v => `translateX:${v}%`);
    const directionFactor = useRef<number>(1);

    useAnimationFrame((t, delta) => {
        const moveBy = directionFactor.current * baseVelocity * (delta / 1000);

        baseX.set(baseX.get() + moveBy);
    });

    return (
        <div className="parallax w-full">
            <motion.div
                className="scroller flex flex-row items-center justify-center gap-x-8 xl:gap-x-12"
                style={{ x }}
                transition={{ yoyo: "Infinity" }}
            >
                {children}
            </motion.div>
        </div>
    );
}

const ScrollVelocity = () => {
    const isDesktop = useIsDesktop();

    return (
        <div className="mb-section-lg w-full overflow-hidden">
            <div className="mx-auto max-w-screen-lg px-5 xl:px-0">
                <div className="mt-section">
                    <p className="inline-flex items-center justify-center gap-2.5 rounded-[50px] bg-neutral-50 px-4 py-2.5 text-body font-normal leading-none text-black outline outline-1 outline-offset-[-1px] outline-gray-200">
                        Reference
                    </p>
                    <p className="mb-14 mt-4 text-h2 font-bold leading-tight text-slate-900 sm:mb-12 sm:text-h1">
                        케이유융합소프트웨어연구센터
                        <br className="md:hidden" />
                        (KUSRC)와{" "}
                        <br className="hidden md:block" />
                        함께합니다.
                    </p>
                </div>
            </div>

            {isDesktop ? <PartnerMarquee /> : <PartnerGrid />}
        </div>
    );
};

export default ScrollVelocity;
